<template>
	<!--  ViewClassroomBoardList.vue: 강의실 > 게시판 > 게시물목록 화면 (notice.html) -->
	<fragment v-if="lecture">
		<class-header
			:subname="lecture.category"
			:name="lecture.lecName"
			v-bind:menus="menus"
			v-bind:buttons="buttons"
			v-bind:mainmenuOpened="true"
			v-bind:sysmenuActive="false"
			:icon="lecture.lecIcon?lecture.lecIcon.atchFileId:''"
		></class-header>

		<section ref="container" class="container">
			<common-side-menu :menus="side_menus" :btnList="side_buttons"></common-side-menu>

			<div class="container-fiuld clearfix" v-if="selectedBoard">
				<div class="title-box m-b-30 b-b clearfix">
					<div class="f-18 pull-left text-blue p-10">
						{{selectedBoard.boardName}}
						<router-link class="modify" :to="'/classroom/'+$route.params.lecId+'/board/'+$route.params.boardId+'/modify'"></router-link>
						<a class="del" @click="deleteBoard"></a>
					</div>
				</div>
				<div class="btn-group pull-right m-b-15 clearfix">
					<div class="search-box pull-left">
						<input id="search" class="form-control round full-width m-b-0" type="text" v-model="keyword">
						<label for="search" style="width: 30px;height: 30px;background-size: 20px;" @click="searchByKeyword">검색</label>
					</div>
				</div>
				<!-- //end .btn-group -->
				<table class="table2 table-hover text-center">
					<thead>
						<tr class="bg-lightgray">
							<!--th>
								<input id="table-allcheck" class="checkbox" type="checkbox" :checked="allSelected" @change="selectAll">
								<label for="table-allcheck">체크버튼</label>
							</th-->
							<th>#</th>
							<th>분류</th>
							<th>제목</th>
							<th>작성자</th>
							<th>작성일</th>
							<th>조회</th>
						</tr>
					</thead>
					<tbody v-for="(article, idx) in articles" :key="`article-id-${article.articleId}`">
						<tr class="margin">
							<td colspan="7"></td>
						</tr>
						<tr>
							<!--td>
								<input :id="`article-check-${hash(article)}`" class="checkbox" type="checkbox" v-model="article.selected">
								<label :for="`article-check-${hash(article)}`">체크버튼</label>
							</td-->
							<td>
								{{totalCount - offset - idx}}
							<td>
								{{article.articleCategoryNm}}
							</td>
							<td style="text-align: left;" @click="$router.push('/classroom/'+$route.params.lecId+'/board/'+article.boardId+'/detail/'+article.articleId)">
								<span v-for="(i, idx) in new Array(article.depth?article.depth:0)" :key="'space-for-'+article.articleId+'-'+idx">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
								<span v-if="article.depth>0">[답글]</span> {{article.title}}
							</td>
							<td>
								{{article.mberId}}
							</td>
							<td>
								{{article.regDate}}
							</td>
							<td>
								{{article.lookupCount}}
							</td>
						</tr>
					</tbody>
				</table>

				<ctrl-pagination :currentPage="offset / pageSize + 1"
					:pageSize="pageSize" :totalCount="totalCount"
					:key="hash({pageSize, offset, totalCount})"
					@pageChanged="onPageChanged"></ctrl-pagination>
			</div>
		</section>
		<common-footer></common-footer>

		<modal-confirm :config="modals.ModalConfirm" @yes="modals.ModalConfirm.show=false" @no="modals.ModalConfirm.show=false" :key="hash(modals.ModalConfirm)"></modal-confirm>
		<modal-alert :config="modals.ModalAlert" @close="modals.ModalAlert.show=false;" :key="hash(modals.ModalAlert)"></modal-alert>
	</fragment>
</template>

<script>
import fnAdjustHeight from '../mixins/fnAdjustHeight.js'
import fnGetLec from '../mixins/fnGetLec.js'
import ClassHeader from '../components/ClassHeader.vue'
import CommonFooter from '../components/CommonFooter.vue'
import CommonSideMenu from '../components/CommonSideMenu.vue'
import CtrlPagination from '../components/CtrlPagination.vue'

import ModalConfirm from '../modals/ModalConfirm.vue'
import ModalAlert from '../modals/ModalAlert.vue'

import Axios from 'axios'
import server from '../statics/server.js'

export default {
	// 컴포넌트 명
	name: 'ViewClassroomBoardRegister',
	mixins: [
		fnAdjustHeight,
		fnGetLec
	],
	// 이 컴포넌트에서 사용할 자식컴포넌트 목록
	components: {
		ClassHeader,
		CommonFooter,
		CtrlPagination,
		CommonSideMenu,
		ModalConfirm,
		ModalAlert,
	},
	mounted: async function() {
		const { lecId } = this.$route.params;
		this.lecture = await this.getLecInfo(lecId);
		if(this.lecture.classroomOpt.indexOf("출결")==-1) this.menus.splice( this.menus.indexOf(this.menus.find(e=>e.name=='출결')), 1 );
		if(this.lecture.classroomOpt.indexOf("과제")==-1) this.menus.splice( this.menus.indexOf(this.menus.find(e=>e.name=="과제")), 1 );
		if(this.lecture.classroomOpt.indexOf("설문")==-1) this.menus.splice( this.menus.indexOf(this.menus.find(e=>e.name=='설문')), 1 );
		if(this.lecture.classroomOpt.indexOf("시험")==-1) this.menus.splice( this.menus.indexOf(this.menus.find(e=>e.name=='시험')), 1 );
		//if(this.lecture.classroomOpt.indexOf("동영상 등록")==-1) this.menus.splice( this.menus.indexOf(this.menus.find(e=>e.name=='강의 목차')), 1 );
		this.side_menus = await this.getBoardSideMenus(lecId);
		this.getArticles();
	},
	// 이 컴포넌트에서 내부적으로 사용할 데이터
	data: function() {
		const { lecId } = this.$route.params;

		let buttons = [
			{name: '게시판 만들기', fn: () => {this.$router.push(`/classroom/${lecId}/board/register`);}},
		];
		if(this.$route.params.boardId) {
			buttons.unshift({name: "게시물 작성", fn: () => {this.$router.push(`/classroom/${lecId}/board/${this.$route.params.boardId}/write`)}})
		}
		return {
			lecture: null,
			menus : [
				{name:'강의 목차',link:"/classroom/"+this.$route.params.lecId+"/curriculum",selected:false},
				{name:'수강관리',link:"/classroom/"+this.$route.params.lecId+"/apply",selected:false},
				{name:'출결',link:"/classroom/"+this.$route.params.lecId+"/attendance",selected:false},
				{name:'시험',link:"/classroom/"+this.$route.params.lecId+"/exam",selected:false},
				{name:'과제',link:"/classroom/"+this.$route.params.lecId+"/assignment",selected:false},
				{name:'설문',link:"/classroom/"+this.$route.params.lecId+"/survey",selected:false},
				{name:'게시판',link:"/classroom/"+this.$route.params.lecId+"/board",selected:true},
			],
			side_menus: [],
			side_buttons : [],
			buttons,
			modals: {
				ModalConfirm: ModalConfirm.default(),
				ModalAlert: ModalAlert.default(),
			},

			selectedBoard: null,
			articles: [],
			keyword: "",
			totalCount: 0,
			pageSize: 30,
			offset: 0,
		}
	},
	// 이 컴포넌트에서 내부적으로 사용할 메써드
	methods: {
		getArticles: async function() {
			const { boardId } = this.$route.params;
			if(!boardId) return;

			try {
				const { pageSize, offset, keyword } = this;
				const { data } = await Axios.post(`${server.addr()}${server.api.ARTICLE}`, {
					boardId, pageSize, offset, keyword
				});
				this.articles = data.list.map(e=>{ e["selected"] = false; return e; });
				this.totalCount = parseInt(data.filtered);
			} catch(e) {
				// TODO : error exception
			}
		},
		searchByKeyword: function(keyword) {
			this.offset = 0;
			this.keyword = keyword;
			this.getArticles()
		},
		selectAll: function() {
			const targetBool = !this.articles.reduce((prev, curr) => prev && curr.selected , true);
			this.articles.forEach(art=>{
				art.selected = targetBool;
			});
		},
		// 페이지네이션 이벤트 핸들러
		onPageChanged: function(page) {
			const { pageSize } = this;
			this.offset = (page - 1) * pageSize;

			this.getArticles();
		},
		deleteBoard: function() {
			this.modals.ModalConfirm.msg = "정말 게시판을 삭제하시겠습니까?";
			this.modals.ModalConfirm.btnYes.name = "취소";
			this.modals.ModalConfirm.btnYes.fn = () => { this.modals.ModalConfirm.show = false; };
			this.modals.ModalConfirm.btnNo.name = "게시판 삭제";
			this.modals.ModalConfirm.btnNo.fn = () => {
				Axios.delete(server.addr()+server.api.BOARD+"/"+this.$route.params.boardId).then(() => {
					this.modals.ModalConfirm.show = false;
					this.modals.ModalAlert.msg = "게시판이 삭제되었습니다.";
					this.modals.ModalAlert.btn.fn = () => {
						this.$router.push("/classroom/"+this.$route.params.lecId+"/board");
					}
					this.modals.ModalAlert.show = true;
				})
			}
			this.modals.ModalConfirm.show = true;
		}
	}
}
</script>
<style scope>
	tr {height: 50px;}

	.recycle {
		fill: #fff;
		fill-rule: evenodd;
	}

	.btn-group .btn:hover .recycle {
		fill: #fff;
		fill-rule: evenodd;
	}
</style>
